/* eslint-disable */

import { useTranslation as useUiTranslation } from "react-i18next";
const PaymentProofModal = ({ isOpen, onClose, paymentProof }) => {
  const { t: uiT } = useUiTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-4xl max-h-[90vh] overflow-hidden shadow-2xl  w-full">
        <div className="bg-gradient-to-r from-[#fbe9ff] to-[#fce7ff] px-6 py-4 border-b">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="bg-white p-2 rounded-full mr-3">
                <svg
                  className="w-5 h-5 text-[#9e68ba]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#9e68ba]">
                {uiT("ui.paymentProofPhoto")}
              </h3>
            </div>
            <button
              onClick={onClose}
              className="text-[#9e68ba] hover:text-[#814a9f] transition-colors duration-200 p-1"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Contenu du modal */}
        <div className="p-6 overflow-auto max-h-[calc(90vh-120px)]">
          <div className="text-center">
            <img
              src={paymentProof}
              alt={uiT("foorcall_stats.payment.proof_of_payment")}
              className="max-w-full max-h-[70vh] mx-auto rounded-lg shadow-lg border-2 border-gray-200"
            />

            {/* Boutons d'action */}
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <button
                onClick={() => window.open(paymentProof, "_blank")}
                className="bg-[#9b59bf] hover:bg-[#814a9f] text-white px-6 py-3 rounded-lg font-medium transition-colors duration-200 flex items-center gap-2"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
                {uiT("ui.openNewWindow")}
              </button>

              <button
                onClick={onClose}
                className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-3 rounded-lg font-medium transition-colors duration-200"
              >
                {uiT("video.close")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentProofModal;
